import { useState, useEffect } from 'react';
import { api } from '../api';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export default function NotificationPrompt() {
  const [show, setShow] = useState(false);
  const [subscribing, setSubscribing] = useState(false);

  useEffect(() => {
    // Don't show if notifications or push not supported
    if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) return;
    // Don't show if already granted or denied
    if (Notification.permission !== 'default') return;
    // Don't show if dismissed this session
    if (sessionStorage.getItem('notif-dismissed')) return;

    // Wait a few seconds after page load so it's not overwhelming
    const timer = setTimeout(() => setShow(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  // Also auto-subscribe if permission was already granted (e.g. on page reload)
  useEffect(() => {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return;
    if (!('PushManager' in window)) return;
    if (Notification.permission === 'granted') {
      subscribeToPush().catch(console.error);
    }
  }, []);

  async function subscribeToPush() {
    try {
      const reg = await navigator.serviceWorker.ready;
      const { publicKey } = await api.getVapidKey();

      const subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });

      await api.subscribePush(subscription.toJSON());
      console.log('[Push] Subscribed successfully');
    } catch (err) {
      console.error('[Push] Subscribe failed:', err);
    }
  }

  async function handleEnable() {
    setSubscribing(true);
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        await subscribeToPush();
      }
    } catch (err) {
      console.error('[Push] Permission error:', err);
    }
    setShow(false);
    setSubscribing(false);
  }

  function handleDismiss() {
    setShow(false);
    sessionStorage.setItem('notif-dismissed', '1');
  }

  if (!show) return null;

  return (
    <div className="notif-banner">
      <div className="install-banner-text">
        <strong>Enable Notifications</strong>
        <span>Get alerted when new calls come in</span>
      </div>
      <div className="install-banner-actions">
        <button className="btn btn-sm btn-gold" onClick={handleEnable} disabled={subscribing}>
          {subscribing ? 'Enabling...' : 'Enable'}
        </button>
        <button className="btn btn-sm btn-muted" onClick={handleDismiss}>Not now</button>
      </div>
    </div>
  );
}
